import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      anchors: [...this.el.querySelectorAll('.our-expertise-grid-v2__grid a')],
      tags: [...this.el.querySelectorAll('.our-expertise-grid-v2__grid p')]
    };

    this.opacityClass = 'our-expertise-grid-v2__grid--opacity';
    this.noOpacityClass = 'our-expertise-grid-v2__grid--no-opacity';

    this.dom.tags.forEach(tag => tag.setAttribute('aria-disabled', true));

    this.isMobile = window.matchMedia('(max-width: 1024px)').matches; // this is the breakpoint set for mobile in _variables.scss
  }

  addListeners() {
    if (this.isMobile) return;

    this.dom.anchors.forEach(anchor =>
      anchor.addEventListener('mouseenter', ::this.showFocus)
    );
    this.dom.anchors.forEach(anchor =>
      anchor.addEventListener('mouseleave', ::this.hideFocus)
    );
  }

  showFocus(event) {
    this.getElements(event).forEach(link => {
      link.classList.add(this.opacityClass);
      link.setAttribute('aria-disabled', true);
    });

    event.currentTarget.classList.add(this.noOpacityClass);
    event.currentTarget.setAttribute('aria-disabled', false);
  }

  hideFocus(event) {
    this.getElements(event).forEach(link => {
      link.classList.remove(this.opacityClass, this.noOpacityClass);
      link.setAttribute('aria-disabled', true);
    });
  }

  getElements(event) {
    return [
      ...event.currentTarget
        .closest('.our-expertise-grid-v2__grid')
        .querySelectorAll('p,a')
    ];
  }
}

export default Module;
